import api from "../services/authService";

/**
 * Per-document "Prepare for AI chat" client.
 *
 * Backend surface (dms_backend PR #1220):
 *   GET  /api/documents/<id>/ai-readiness/  — where the document sits on
 *        the path to chat-ability. States:
 *        not_ready | materializing | queued | extracting | embedding |
 *        ready | failed. `ready` means the retrieval surface exists
 *        (extracted markdown + chunk rows), regardless of which pipeline
 *        mode produced it.
 *   POST /api/documents/<id>/ai-prepare/    — idempotent kick-off of the
 *        extract+embed pipeline for one PDF (including on-demand
 *        DocRio→S3 materialization for legacy documents). Returns 202
 *        when work was enqueued, 200 when already ready/in flight, 503
 *        when the feature flag is off.
 *
 * All calls route through the shared `authService` axios instance so JWT +
 * 401 refresh stay consistent with the rest of the app.
 */

export const fetchAiReadiness = async (documentId) => {
  const response = await api.get(`/documents/${documentId}/ai-readiness/`);
  return response.data;
};

export const triggerAiPrepare = async (documentId) => {
  const response = await api.post(`/documents/${documentId}/ai-prepare/`);
  return response.data;
};
